import { Box, Container, Text, FlexProps, SimpleGrid } from '@chakra-ui/react';
import { Header } from '../../atoms/Header';
import { Card } from '../../molecules/Card';

export const HowItWorks: React.FC<FlexProps> = () => {
  return (
    <Box bg="white" color="text.darkBlue.900" pt={{ base: 16, md: 24 }}>
      <Container maxW={'container.xl'}>
        <Header>
          How MERKATUS.IO Works{' '}
          <Text
            fontSize="xl"
            color="gray.600"
            fontFamily="marketingPage"
            fontWeight="medium"
            textTransform="uppercase"
            mb={{ base: 8, md: 12 }}>
            Start seeing your marketing’s real impact in 3 simple steps
          </Text>
        </Header>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
          <Card iconName="upload" headerText="Connect Your Data">
            <Text
              lineHeight="24px"
              fontSize="sm"
              my={9}
              color="gray.600"
              fontFamily="marketingPage">
              Plug in your sales, media, and campaign data digital and offline.
              We support integrations and manual uploads.
            </Text>
            <Text
              textAlign="end"
              lineHeight="54px"
              fontSize="6xl"
              fontFamily="marketingPage">
              01
            </Text>
          </Card>
          <Card
            iconName="aiDoc"
            headerText="Get AI-Powered Models Tailored to Your Market">
            <Text
              lineHeight="24px"
              fontSize="sm"
              color="gray.600"
              mt={3}
              mb={9}
              fontFamily="marketingPage">
              Our platform builds advanced, localized models that show which
              marketing actions drive results now and over time.
            </Text>
            <Text
              textAlign="end"
              lineHeight="54px"
              fontSize="6xl"
              fontFamily="marketingPage">
              02
            </Text>
          </Card>
          <Card iconName="growth" headerText="Optimize & Grow with Confidence">
            <Text
              lineHeight="24px"
              fontSize="sm"
              my={9}
              color="gray.600"
              fontFamily="marketingPage">
              Use our dashboards and scenarios to test budget shifts, justify
              spending, and drive smarter growth backed by data.
            </Text>
            <Text
              textAlign="end"
              lineHeight="54px"
              fontSize="6xl"
              fontFamily="marketingPage">
              03
            </Text>
          </Card>
        </SimpleGrid>
      </Container>
    </Box>
  );
};
